@let hero = data();

<div
  class="hero-overlay"
  [class.hero-overlay--small]="hero.containerWidth === 'small'"
  [class.hero-overlay--medium]="hero.containerWidth === 'medium'"
  [class.hero-overlay--large]="hero.containerWidth === 'large'"
  [style.--hero-min-height.vh]="hero.overlayMinHeight"
>
  <div class="hero-overlay__img">
    <picture [paiPicture]="hero.image" size="100vw" priority></picture>
  </div>
  <div class="hero-overlay__content">
    <h1 tabindex="-1">{{ hero.title }}</h1>
    <p [innerText]="hero.intro"></p>
    <!--    todo-->
    <!--    <ng-template [paiInsertDynamicComponent]="cta" />-->
  </div>
</div>
